"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockOptions = exports.BlockBody = exports.BlockHeaderInputs = exports.BlockHeaderActions = exports.BlockTitle = exports.BlockHeader = exports.Block = void 0;
const React = require("react");
const Section_1 = require("../../abstract/Section");
const Header_1 = require("../../abstract/Section/components/Header");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const styles = require("./styles.scss");
const css = (0, cssComposer_1.default)(styles, "block");
const Block = ({ children, open = true, isCollapsible = true }) => (React.createElement(Section_1.Section, { className: css(""), isCollapsible: isCollapsible, open: open, size: "sm" }, children));
exports.Block = Block;
/**
 * Renders a block header
 */
const BlockHeader = (_a) => {
    var { children, isSticky = false, className = "", actions, label } = _a, rest = __rest(_a, ["children", "isSticky", "className", "actions", "label"]);
    return (React.createElement(Section_1.Header, Object.assign({ className: className, isSticky: isSticky, actions: actions, label: label }, rest), children));
};
exports.BlockHeader = BlockHeader;
const BlockTitle = ({ className = "", children }) => (React.createElement(Section_1.Title, { size: 4, className: className }, children));
exports.BlockTitle = BlockTitle;
const BlockHeaderActions = ({ children }) => React.createElement(Header_1.HeaderActions, null, children);
exports.BlockHeaderActions = BlockHeaderActions;
const BlockHeaderInputs = ({ children }) => React.createElement(Header_1.HeaderInputs, null, children);
exports.BlockHeaderInputs = BlockHeaderInputs;
/**
 * Main content of a block.
 */
const BlockBody = ({ children, className = "" }) => {
    return React.createElement(Section_1.Body, { className: className }, children);
};
exports.BlockBody = BlockBody;
/**
 * Renders a block header
 */
const BlockOptions = (_a) => {
    var { className = "" } = _a, rest = __rest(_a, ["className"]);
    return React.createElement(Section_1.Options, Object.assign({}, rest));
};
exports.BlockOptions = BlockOptions;
//# sourceMappingURL=index.js.map